const 중복체크 = {
    "경기 고양시시 일산동구 마두동 789": {
        "강촌마을라이프아파트5단지2차": {
            "apt_name": "강촌마을라이프아파트5단지2차",
            "addr": "경기 고양시시 일산동구 마두동 789",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 30,
            "장애요인": "있음",
            "장애내용": "열쇠보관함에 열쇠 미비치(도난우려)"
        },
        "강촌마을라이프아파트5단지1차": {
            "apt_name": "강촌마을라이프아파트5단지1차",
            "addr": "경기 고양시시 일산동구 마두동 789",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 20,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 고양시시 일산동구 사리현동 186": {
        "사리현동문굿모닝힐2단지": {
            "apt_name": "사리현동문굿모닝힐2단지",
            "addr": "경기 고양시시 일산동구 사리현동 186",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 1200,
            "장애요인": "있음",
            "장애내용": "박공지붕으로 옥상출입문을 통해 나가면 지붕 공간이 나오고 출입문을 통해 대피공간으로 나감"
        },
        "동문굿모닝힐1단지": {
            "apt_name": "동문굿모닝힐1단지",
            "addr": "경기 고양시시 일산동구 사리현동 186",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 560,
            "장애요인": "있음",
            "장애내용": "박공지붕으로 옥상출입문을 통해 나가면 지붕 공간이 나오고 출입문을 통해 대피공간으로 나감"
        },
    },
  "경기 과천시 부림동 41": {
        "부림동 과천주공8단지": {
            "apt_name": "부림동 과천주공8단지",
            "addr": "경기 과천시 부림동 41",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 765,
            "장애요인": "없음",
            "장애내용": ""
        },
        "과천주공9단지": {
            "apt_name": "부림동 과천주공9단지",
            "addr": "경기 과천시 부림동 41",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 군포시 금정동 875": {
        "금정동 주공3단지퇴계1차": {
            "apt_name": "금정동 주공3단지퇴계1차",
            "addr": "경기 군포시 금정동 875",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "100 이상",
            "장애요인": "없음",
            "장애내용": ""
        },
        "금정동 주공3단지퇴계2차": {
            "apt_name": "금정동 주공3단지퇴계2차",
            "addr": "경기 군포시 금정동 875",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "100 이상",
            "장애요인": "있음",
            "장애내용": "계단 방법창 설치"
        },
    },
    "경기 군포시 당동 874": {
        "당동 주공2단지1": {
            "apt_name": "당동 주공2단지1",
            "addr": "경기 군포시 당동 874",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "당동 주공2단지2": {
            "apt_name": "당동 주공2단지2",
            "addr": "경기 군포시 당동 874",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 군포시 산본동 1155-7": {
        "산본동 가야주공5단지3차": {
            "apt_name": "산본동 가야주공5단지3차",
            "addr": "경기 군포시 산본동 1155-7",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "10 미만",
            "장애요인": "없음",
            "장애내용": ""
        },
        "산본가야2차아파트": {
            "apt_name": "산본가야2차아파트",
            "addr": "경기 군포시 산본동 1155-7",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "10~30",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 남양주시시 다산동 4002-1": {
        "다산동 부영그린타운1단지": {
            "apt_name": "다산동 부영그린타운1단지",
            "addr": "경기 남양주시시 다산동 4002-1",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 20,
            "장애요인": "없음",
            "장애내용": ""
        },
        "다산동 부영그린타운2단지": {
            "apt_name": "다산동 부영그린타운2단지",
            "addr": "경기 남양주시시 다산동 4002-1",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 8,
            "장애요인": "있음",
            "장애내용": "화문으로 나오자 마자 박공지붕 벽면이 있고 양옆으로 난간이있음 단일 라인인 곳은 그곳이 대피 공간이고 옆 라인이 있는 동은 옆 라인으로 이동 하여 피난 하면 됨"
        },
        "다산동 부영그린타운3단지": {
            "apt_name": "다산동 부영그린타운3단지",
            "addr": "경기 남양주시시 다산동 4002-1",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "사진참조"
        },
        "다산동 부영그린타운4단지": {
            "apt_name": "다산동 부영그린타운4단지",
            "addr": "경기 남양주시시 다산동 4002-1",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "박공지붕의 출입문"
        },
        "다산동 부영그린타운5단지": {
            "apt_name": "다산동 부영그린타운5단지",
            "addr": "경기 남양주시시 다산동 4002-1",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "박공지붕의 출입문"
        },
    },
    "경기 남양주시시 별내동 895": {
        "별내동 별내우미린스타포레": {
            "apt_name": "별내동 별내우미린스타포레",
            "addr": "경기 남양주시시 별내동 895",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "최상층과 동일",
            "장애요인": "없음",
            "장애내용": ""
        },
        "별내우미린스타포레": {
            "apt_name": "별내우미린스타포레",
            "addr": "경기 남양주시시 별내동 895",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 250,
            "장애요인": "없음",
            "장애내용": ""
        },
    },



    "경기 동두천시 동두천동 524-1": {
        "동두천신창비바패밀리1단지": {
            "apt_name": "동두천신창비바패밀리1단지",
            "addr": "경기 동두천시 동두천동 524-1",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 200,
            "장애요인": "없음",
            "장애내용": ""
        },
        "동두천신창비바패밀리2단지": {
            "apt_name": "동두천신창비바패밀리2단지",
            "addr": "경기 동두천시 동두천동 524-1",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 200,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 부천시시 상동 397": {
        "상동 반달마을건영": {
            "apt_name": "상동 반달마을건영",
            "addr": "경기 부천시시 상동 397",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 396,
            "장애요인": "없음",
            "장애내용": ""
        },
        "상동 반달마을동아": {
            "apt_name": "상동 반달마을동아",
            "addr": "경기 부천시시 상동 397",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 200,
            "장애요인": "없음",
            "장애내용": ""
        },
        "상동 반달마을선경": {
            "apt_name": "상동 반달마을선경",
            "addr": "경기 부천시시 상동 397",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 13266,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 부천시시 중동 1028": {
        "한라마을주공1단지": {
            "apt_name": "한라마을주공1단지",
            "addr": "경기 부천시시 중동 1028",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 160,
            "장애요인": "있음",
            "장애내용": "옥상 출입문 가기 전 중문(철문)이 설치되어 있음"
        },
        "중동 한라마을주공2단지": {
            "apt_name": "중동 한라마을주공2단지",
            "addr": "경기 부천시시 중동 1028",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 336,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 부천시시 중동 1041": {
        "덕유마을주공4단지": {
            "apt_name": "덕유마을주공4단지",
            "addr": "경기 부천시시 중동 1041",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 3550.05,
            "장애요인": "없음",
            "장애내용": ""
        },
        "중동 덕유마을주공2단지": {
            "apt_name": "중동 덕유마을주공2단지",
            "addr": "경기 부천시시 중동 1041",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "2288(2개합)",
            "장애요인": "있음",
            "장애내용": "옥상 올라가는 계단상 미닫이식 스텐방범창(열쇠 비치)"
        },
    },
    "경기 부천시시 중동 1186": {
        "중동 중동복사골건영1차": {
            "apt_name": "중동 중동복사골건영1차",
            "addr": "경기 부천시시 중동 1186",
            "지붕형태": "슬라브",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "복사골건영2차": {
            "apt_name": "복사골건영2차",
            "addr": "경기 부천시시 중동 1186",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 99,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 성남시 분당구 구미동 211": {
        "분당무지개마을대림": {
            "apt_name": "분당무지개마을대림",
            "addr": "경기 성남시 분당구 구미동 211",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 5,
            "장애요인": "없음",
            "장애내용": ""
        },
        "무지개5단지청구": {
            "apt_name": "무지개5단지청구",
            "addr": "경기 성남시 분당구 구미동 211",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 100,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 성남시 분당구 백현동 525": {
        "백현동 백현마을9단지": {
            "apt_name": "백현동 백현마을9단지",
            "addr": "경기 성남시 분당구 백현동 525",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 7,
            "장애요인": "없음",
            "장애내용": ""
        },
        "백현9단지휴먼시아e-편한세상": {
            "apt_name": "백현9단지휴먼시아e-편한세상",
            "addr": "경기 성남시 분당구 백현동 525",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 250,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 성남시 분당구 백현동 558": {
        "백현마을8단지아파트": {
            "apt_name": "백현마을8단지아파트",
            "addr": "경기 성남시 분당구 백현동 558",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 7,
            "장애요인": "있음",
            "장애내용": "공간협소"
        },
        "백현8단지휴먼시아": {
            "apt_name": "백현8단지휴먼시아",
            "addr": "경기 성남시 분당구 백현동 558",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 150,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 성남시 분당구 수내동 27": {
        "양지3,5단지금호,한양": {
            "apt_name": "양지3,5단지금호,한양",
            "addr": "경기 성남시 분당구 수내동 27",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "양지마을한양아파트2차": {
            "apt_name": "양지마을한양아파트2차",
            "addr": "경기 성남시 분당구 수내동 27",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 100,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 성남시 분당구 이매동 132": {
        "이매동 아름마을한성": {
            "apt_name": "이매동 아름마을한성",
            "addr": "경기 성남시 분당구 이매동 132",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "이매동 아름마을태영": {
            "apt_name": "이매동 아름마을태영",
            "addr": "경기 성남시 분당구 이매동 132",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 300,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 수원시 팔달구 우만동 28": {
        "우만동 우만주공1단지": {
            "apt_name": "우만동 우만주공1단지",
            "addr": "경기 수원시 팔달구 우만동 28",
            "지붕형태": "슬라브",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "기타",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "5층APT로수직사다리올라약0.5X0.5m 철뚜껑열고 나갈수 있음"
        },
        "우만동 우만주공2단지": {
            "apt_name": "우만동 우만주공2단지",
            "addr": "경기 수원시 팔달구 우만동 28",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 수원시 팔달구 화서동 650": {
        "화서동 화서주공4단지": {
            "apt_name": "화서동 화서주공4단지",
            "addr": "경기 수원시 팔달구 화서동 650",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 33,
            "장애요인": "있음",
            "장애내용": "옥상 출입문이 박공지붕 아래이며 다른 라인을 통해 대피 가능"
        },
        "화서동 화서주공5단지": {
            "apt_name": "화서동 화서주공5단지",
            "addr": "경기 수원시 팔달구 화서동 650",
            "지붕형태": "박공",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "혼재(방화문, 가연재)",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 시흥시시 대야동 284": {
        "대야동 영남1차": {
            "apt_name": "대야동 영남1차",
            "addr": "경기 시흥시시 대야동 284",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "537.25`",
            "장애요인": "있음",
            "장애내용": "5층아파트로 5층에서 벽에 부착된 고정식 사다리를 이용하여 옥상출입문에 진입하는 구조로 노약자가 이용하기에 어려움"
        },
        "대야동 영남2차": {
            "apt_name": "대야동 영남2차",
            "addr": "경기 시흥시시 대야동 284",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 771.56,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 안산시 단원구 선부동 1078": {
        "선부동 군자주공11단지": {
            "apt_name": "선부동 군자주공11단지",
            "addr": "경기 안산시 단원구 선부동 1078",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "각 동별 30",
            "장애요인": "없음",
            "장애내용": ""
        },
        "선부동 군자주공12단지": {
            "apt_name": "선부동 군자주공12단지",
            "addr": "경기 안산시 단원구 선부동 1078",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 620,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 안산시 단원구 선부동 1079": {
        "선부동 군자주공13단지": {
            "apt_name": "선부동 군자주공13단지",
            "addr": "경기 안산시 단원구 선부동 1079",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 1477,
            "장애요인": "없음",
            "장애내용": ""
        },
        "선부동 군자주공14단지": {
            "apt_name": "선부동 군자주공14단지",
            "addr": "경기 안산시 단원구 선부동 1079",
            "지붕형태": "박공",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "박공지붕으로 대피공간활용 불가"
        },
    },
    "경기 안산시 상록구 월피동 446": {
        "월피주공2단지": {
            "apt_name": "월피주공2단지",
            "addr": "경기 안산시 상록구 월피동 446",
            "지붕형태": "박공",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "박공지붕으로 대피공간활용 불가"
        },
        "월피주공3단지": {
            "apt_name": "월피주공3단지",
            "addr": "경기 안산시 상록구 월피동 446",
            "지붕형태": "박공",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "있음",
            "장애내용": "박공지붕으로 대피공간없음"
        },
    },
    "경기 안양시시 동안구 평촌동 933-7": {
        "평촌동 꿈마을동아": {
            "apt_name": "평촌동 꿈마을동아",
            "addr": "경기 안양시시 동안구 평촌동 933-7",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 70,
            "장애요인": "없음",
            "장애내용": ""
        },
        "평촌동 꿈마을건영3차": {
            "apt_name": "평촌동 꿈마을건영3차",
            "addr": "경기 안양시시 동안구 평촌동 933-7",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 안양시시 동안구 호계동 1055-1": {
        "호계동 무궁화건영": {
            "apt_name": "호계동 무궁화건영",
            "addr": "경기 안양시시 동안구 호계동 1055-1",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 31,
            "장애요인": "없음",
            "장애내용": ""
        },
        "무궁화코오롱": {
            "apt_name": "무궁화코오롱",
            "addr": "경기 안양시시 동안구 호계동 1055-1",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 기흥구 보라동 564": {
        "보라마을현대모닝사이드2차": {
            "apt_name": "보라마을현대모닝사이드2차",
            "addr": "경기 용인시시 기흥구 보라동 564",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
        "보라마을현대모닝사이드": {
            "apt_name": "보라마을현대모닝사이드",
            "addr": "경기 용인시시 기흥구 보라동 564",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 300,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 기흥구 상하동 447": {
        "풍림아파트": {
            "apt_name": "풍림아파트",
            "addr": "경기 용인시시 기흥구 상하동 447",
            "지붕형태": "박공, 슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층, 최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": "50, 200",
            "장애요인": "있음, 없음",
            "장애내용": "생활용품 등 적치"
        },
        "상하동풍림아파트": {
            "apt_name": "상하동풍림아파트",
            "addr": "경기 용인시시 기흥구 상하동 447",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 기흥구 영덕동 1021": {
        "휴먼시아 흥덕마을4단지": {
            "apt_name": "휴먼시아 흥덕마을4단지",
            "addr": "경기 용인시시 기흥구 영덕동 1021",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 800,
            "장애요인": "없음",
            "장애내용": ""
        },
        "흥덕마을4단지휴먼시아아파트": {
            "apt_name": "흥덕마을4단지휴먼시아아파트",
            "addr": "경기 용인시시 기흥구 영덕동 1021",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 기흥구 중동 1046": {
        "초당마을코아루": {
            "apt_name": "초당마을코아루",
            "addr": "경기 용인시시 기흥구 중동 1046",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 80,
            "장애요인": "없음",
            "장애내용": ""
        },
        "초당마을코아루13-1": {
            "apt_name": "초당마을코아루13-1",
            "addr": "경기 용인시시 기흥구 중동 1046",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 기흥구 하갈동 632": {
        "청명호수마을신안인스빌2단지": {
            "apt_name": "청명호수마을신안인스빌2단지",
            "addr": "경기 용인시시 기흥구 하갈동 632",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 300,
            "장애요인": "없음",
            "장애내용": ""
        },
        "하갈동 청명호수마을신안인스빌2단지": {
            "apt_name": "하갈동 청명호수마을신안인스빌2단지",
            "addr": "경기 용인시시 기흥구 하갈동 632",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 300,
            "장애요인": "있음",
            "장애내용": "생활용품 등 적치"
        },
    },
    "경기 용인시시 수지구 동천동 910": {
        "원천마을대우푸르지오아파트": {
            "apt_name": "원천마을대우푸르지오아파트",
            "addr": "경기 용인시시 수지구 동천동 910",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 350,
            "장애요인": "없음",
            "장애내용": ""
        },
        "원천마을푸르지오": {
            "apt_name": "원천마을푸르지오",
            "addr": "경기 용인시시 수지구 동천동 910",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 상현동 825": {
        "상현현대성우2차": {
            "apt_name": "상현현대성우2차",
            "addr": "경기 용인시시 수지구 상현동 825",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 150,
            "장애요인": "없음",
            "장애내용": ""
        },
        "상현마을현대성우2차": {
            "apt_name": "상현마을현대성우2차",
            "addr": "경기 용인시시 수지구 상현동 825",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 성복동 155": {
        "수지LG빌리지1차": {
            "apt_name": "수지LG빌리지1차",
            "addr": "경기 용인시시 수지구 성복동 155",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "없음",
            "장애내용": ""
        },
        "성동마을LG빌리지1차": {
            "apt_name": "성동마을LG빌리지1차",
            "addr": "경기 용인시시 수지구 성복동 155",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 성복동 726": {
        "성복동 엘지빌리지3차": {
            "apt_name": "성복동 엘지빌리지3차",
            "addr": "경기 용인시시 수지구 성복동 726",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 8.85,
            "장애요인": "없음",
            "장애내용": ""
        },
        "성동마을LG빌리지3차": {
            "apt_name": "성동마을LG빌리지3차",
            "addr": "경기 용인시시 수지구 성복동 726",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 신봉동 873": {
        "엘지자이1차": {
            "apt_name": "엘지자이1차",
            "addr": "경기 용인시시 수지구 신봉동 873",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
        "신봉마을LG자이1차": {
            "apt_name": "신봉마을LG자이1차",
            "addr": "경기 용인시시 수지구 신봉동 873",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 350,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 죽전동 1355": {
        "죽전동 성현마을광명샤인빌": {
            "apt_name": "죽전동 성현마을광명샤인빌",
            "addr": "경기 용인시시 수지구 죽전동 1355",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 500,
            "장애요인": "있음",
            "장애내용": "생활용품 등 적치"
        },
        "성현마을광명샤인빌": {
            "apt_name": "성현마을광명샤인빌",
            "addr": "경기 용인시시 수지구 죽전동 1355",
            "지붕형태": "슬라브+박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 용인시시 수지구 풍덕천동 1027": {
        "신정마을6단지진흥": {
            "apt_name": "신정마을6단지진흥",
            "addr": "경기 용인시시 수지구 풍덕천동 1027",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 50,
            "장애요인": "없음",
            "장애내용": ""
        },
        "신정6단지진흥": {
            "apt_name": "신정6단지진흥",
            "addr": "경기 용인시시 수지구 풍덕천동 1027",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층 아래층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 30,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 이천시 부발읍 응암리 96": {
        "응암리 이화1차": {
            "apt_name": "응암리 이화1차",
            "addr": "경기 이천시 부발읍 응암리 96",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 550,
            "장애요인": "없음",
            "장애내용": ""
        },
        "응암리 이화2차": {
            "apt_name": "응암리 이화2차",
            "addr": "경기 이천시 부발읍 응암리 96",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 80,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 평택시 지산동 1029": {
        "지산동 쌍용": {
            "apt_name": "지산동 쌍용",
            "addr": "경기 평택시 지산동 1029",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 1764,
            "장애요인": "없음",
            "장애내용": ""
        },
        "지산동 삼익": {
            "apt_name": "지산동 삼익",
            "addr": "경기 평택시 지산동 1029",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 3493,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 평택시 합정동 829": {
        "평택합정주공3단지아파트": {
            "apt_name": "평택합정주공3단지아파트",
            "addr": "경기 평택시 합정동 829",
            "지붕형태": "슬라브",
            "옥상 대피공간": "없음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "열쇠 또는 번호키",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "평택합정주공4단지아파트": {
            "apt_name": "평택합정주공4단지아파트",
            "addr": "경기 평택시 합정동 829",
            "지붕형태": "슬라브",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "불연재",
            "옥상 출입문 개방관리": "항시개방",
            "유도등 설치여부": "미설치",
            "점등상태": "",
            "대피공간내 난간설치": "미설치",
            "대피공간 면적": 7.645,
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 평택시 합정동 835": {
        "평택합정주공1단지(목화아파트)": {
            "apt_name": "평택합정주공1단지(목화아파트)",
            "addr": "경기 평택시 합정동 835",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
        "평택합정주공2단지": {
            "apt_name": "평택합정주공2단지",
            "addr": "경기 평택시 합정동 835",
            "지붕형태": "박공",
            "옥상 대피공간": "",
            "옥상출입문 설치여부": "미설치",
            "옥상 출입문 위치": "",
            "옥상 출입문 재질": "",
            "옥상 출입문 개방관리": "",
            "유도등 설치여부": "",
            "점등상태": "",
            "대피공간내 난간설치": "",
            "대피공간 면적": "",
            "장애요인": "없음",
            "장애내용": ""
        },
    },
    "경기 화성시 능동 1081": {
        "동탄능동마을주공아파트7-2단지": {
            "apt_name": "동탄능동마을주공아파트7-2단지",
            "addr": "경기 화성시 능동 1081",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 400,
            "장애요인": "없음",
            "장애내용": ""
        },
        "능동마을휴먼시아7단지": {
            "apt_name": "능동마을휴먼시아7단지",
            "addr": "경기 화성시 능동 1081",
            "지붕형태": "박공",
            "옥상 대피공간": "있음",
            "옥상출입문 설치여부": "설치",
            "옥상 출입문 위치": "최상층",
            "옥상 출입문 재질": "방화문",
            "옥상 출입문 개방관리": "자동개폐장치",
            "유도등 설치여부": "설치",
            "점등상태": "점등",
            "대피공간내 난간설치": "설치",
            "대피공간 면적": 72,
            "장애요인": "없음",
            "장애내용": ""
        },
    }
}

const 주소없음 = {
    "부천시 현대아파트": {
    "apt_name": "부천시 현대아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "시흥시 한신공영아파트": {
    "apt_name": "시흥시 한신공영아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 코리아에스이": {
    "apt_name": "용인시 코리아에스이",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 구성아파트": {
    "apt_name": "용인시 구성아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 김도일건물": {
    "apt_name": "용인시 김도일건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 200,
    "장애요인": "있음",
    "장애내용": "물건적치되어 적치물 제거 안내 실시함."
  },
  "용인시 김현미건물(원룸형)": {
    "apt_name": "용인시 김현미건물(원룸형)",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 다온빌와이레노베이션": {
    "apt_name": "용인시 다온빌와이레노베이션",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 다인파크빌": {
    "apt_name": "용인시 다인파크빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 110,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 대명베스트빌": {
    "apt_name": "용인시 대명베스트빌",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 대명아파트": {
    "apt_name": "용인시 대명아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 대우아파트": {
    "apt_name": "용인시 대우아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 대주피오레 1단지": {
    "apt_name": "용인시 대주피오레 1단지",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 도담마을 아이파크": {
    "apt_name": "용인시 도담마을 아이파크",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 도담마을롯데캐슬": {
    "apt_name": "용인시 도담마을롯데캐슬",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 350,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동남아파트": {
    "apt_name": "용인시 동남아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 225,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동부센트레빌": {
    "apt_name": "용인시 동부센트레빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동아솔레시티아파트": {
    "apt_name": "용인시 동아솔레시티아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1000,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동원로얄듀크아파트": {
    "apt_name": "용인시 동원로얄듀크아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동일하이빌 오피스텔": {
    "apt_name": "용인시 동일하이빌 오피스텔",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 동일하이빌1차아파트": {
    "apt_name": "용인시 동일하이빌1차아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 두원아파트": {
    "apt_name": "용인시 두원아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 483,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 라이프타워아파트": {
    "apt_name": "용인시 라이프타워아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 레인보우폴리스(구)우남퍼스트빌리젠트": {
    "apt_name": "용인시 레인보우폴리스(구)우남퍼스트빌리젠트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 마북1차 신원아침도시": {
    "apt_name": "용인시 마북1차 신원아침도시",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 마평원룸": {
    "apt_name": "용인시 마평원룸",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 196,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 명지베스트빌동림프라자": {
    "apt_name": "용인시 명지베스트빌동림프라자",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 명품하우스 A동": {
    "apt_name": "용인시 명품하우스 A동",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 모아미래도": {
    "apt_name": "용인시 모아미래도",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 목화아파트": {
    "apt_name": "용인시 목화아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 물푸레 주공9단지": {
    "apt_name": "용인시 물푸레 주공9단지",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 백순석 건물": {
    "apt_name": "용인시 백순석 건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 보성기숙사": {
    "apt_name": "용인시 보성기숙사",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 120,
    "장애요인": "없음",
    "장애내용": ""
  },
  "삼성전자기숙사": {
    "apt_name": "삼성전자기숙사",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 서은희건물": {
    "apt_name": "용인시 서은희건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 선봉아파트": {
    "apt_name": "용인시 선봉아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 성원아파트(용인시수지성원아파트)": {
    "apt_name": "용인시 성원아파트(용인시수지성원아파트)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 센트리움": {
    "apt_name": "용인시 센트리움",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 송태호 건물": {
    "apt_name": "용인시 송태호 건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 수정아트빌라아파트": {
    "apt_name": "용인시 수정아트빌라아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 수지2차 동보아파트": {
    "apt_name": "용인시 수지2차 동보아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 수지2차삼성아파트": {
    "apt_name": "용인시 수지2차삼성아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 638,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 수지3차현대아파트(만현마을10단지IPARK)": {
    "apt_name": "용인시 수지3차현대아파트(만현마을10단지IPARK)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 수지자이1차아파트": {
    "apt_name": "용인시 수지자이1차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 스위트홈아파트(김량장동 주상복합)": {
    "apt_name": "용인시 스위트홈아파트(김량장동 주상복합)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1000,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 신구그린빌라": {
    "apt_name": "용인시 신구그린빌라",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 600,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 신동백서해그랑블2차아파트": {
    "apt_name": "용인시 신동백서해그랑블2차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 170,
    "장애요인": "있음",
    "장애내용": "장애요인없습니다 사진이계속거꾸로 오려집니다 죄송합니다"
  },
  "용인시 신동아빌라트": {
    "apt_name": "용인시 신동아빌라트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 신명스카이뷰아파트": {
    "apt_name": "용인시 신명스카이뷰아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 신명아파트": {
    "apt_name": "용인시 신명아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 신원아침도시아파트": {
    "apt_name": "용인시 신원아침도시아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 250,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 쌍용스윗닷홈아파트": {
    "apt_name": "용인시 쌍용스윗닷홈아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 쌍용아파트": {
    "apt_name": "용인시 쌍용아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 아델하우스": {
    "apt_name": "용인시 아델하우스",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 에코빌131": {
    "apt_name": "용인시 에코빌131",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 에코빌724": {
    "apt_name": "용인시 에코빌724",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 에코타운2차 A동": {
    "apt_name": "용인시 에코타운2차 A동",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 역북1단지우남퍼스트빌": {
    "apt_name": "용인시 역북1단지우남퍼스트빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 영구아파트": {
    "apt_name": "용인시 영구아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 100,
    "장애요인": "있음",
    "장애내용": "옥상출입문 사다리이용\\n옥상출입문 자물쇠 잠김"
  },
  "용인시 영동아파트94": {
    "apt_name": "용인시 영동아파트94",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 영동아파트95": {
    "apt_name": "용인시 영동아파트95",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 280,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 오정환건물": {
    "apt_name": "용인시 오정환건물",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 온누리아파트": {
    "apt_name": "용인시 온누리아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 용인시구성동양파라곤아파트": {
    "apt_name": "용인시 용인시구성동양파라곤아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 용인시대학교 기숙사": {
    "apt_name": "용인시 용인시대학교 기숙사",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 용인시세무서-기숙사": {
    "apt_name": "용인시 용인시세무서-기숙사",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 189,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 용인시수지 동도센트리움": {
    "apt_name": "용인시 용인시수지 동도센트리움",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우남퍼스트빌 2단지": {
    "apt_name": "용인시 우남퍼스트빌 2단지",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우남퍼스트빌아파트": {
    "apt_name": "용인시 우남퍼스트빌아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우림아파트": {
    "apt_name": "용인시 우림아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 258,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우미린아파트": {
    "apt_name": "용인시 우미린아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우미이노스빌": {
    "apt_name": "용인시 우미이노스빌",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우미이노스빌 5차": {
    "apt_name": "용인시 우미이노스빌 5차",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우미이노스빌아파트": {
    "apt_name": "용인시 우미이노스빌아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우성아파트": {
    "apt_name": "용인시 우성아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 우진에버빌": {
    "apt_name": "용인시 우진에버빌",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층, 최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": "100~200",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 월드드림빌": {
    "apt_name": "용인시 월드드림빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1000,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 월드팰리스": {
    "apt_name": "용인시 월드팰리스",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 웰스하임": {
    "apt_name": "용인시 웰스하임",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유장그린맨션2": {
    "apt_name": "용인시 유장그린맨션2",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유장아트맨션": {
    "apt_name": "용인시 유장아트맨션",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 265,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유장아트맨션건물": {
    "apt_name": "용인시 유장아트맨션건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유장아파트": {
    "apt_name": "용인시 유장아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유창파크맨션1": {
    "apt_name": "용인시 유창파크맨션1",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유창파크맨션2": {
    "apt_name": "용인시 유창파크맨션2",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 유한회사유장주택": {
    "apt_name": "용인시 유한회사유장주택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 80,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 육군용인시관사 한누리마을 벽산아파트": {
    "apt_name": "용인시 육군용인시관사 한누리마을 벽산아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 220,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 이공아트빌": {
    "apt_name": "용인시 이공아트빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 이재준건물": {
    "apt_name": "용인시 이재준건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 이화아파트": {
    "apt_name": "용인시 이화아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 인성마을신갈현대아파트": {
    "apt_name": "용인시 인성마을신갈현대아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 인정멜로디아파트": {
    "apt_name": "용인시 인정멜로디아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 인정베네치아아파트(인정베머루아파트마을베너치아)": {
    "apt_name": "용인시 인정베네치아아파트(인정베머루아파트마을베너치아)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 인정프린스4차아파트": {
    "apt_name": "용인시 인정프린스4차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 인정피렌체빌리지1차아파트": {
    "apt_name": "용인시 인정피렌체빌리지1차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 일봉아파트": {
    "apt_name": "용인시 일봉아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 일진그린맨션": {
    "apt_name": "용인시 일진그린맨션",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 전성민건물": {
    "apt_name": "용인시 전성민건물",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 300,
    "장애요인": "있음",
    "장애내용": "옥상 출입구가 최상층 천장에 위치하여 출입에 장애요인이 있음"
  },
  "용인시 정광APT (구 정광산호APT)": {
    "apt_name": "용인시 정광APT (구 정광산호APT)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 정대철건물(원룸형)": {
    "apt_name": "용인시 정대철건물(원룸형)",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 조양6차아파트": {
    "apt_name": "용인시 조양6차아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 조양맨션": {
    "apt_name": "용인시 조양맨션",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 486,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 조양맨션건물": {
    "apt_name": "용인시 조양맨션건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 조양상가아파트": {
    "apt_name": "용인시 조양상가아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 종흥하우스(구 이동규건물)": {
    "apt_name": "용인시 종흥하우스(구 이동규건물)",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 100,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 주공3단지(성현마을)": {
    "apt_name": "용인시 주공3단지(성현마을)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 주신광주택": {
    "apt_name": "용인시 주신광주택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 240,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 주안빌": {
    "apt_name": "용인시 주안빌",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 죽산박씨호곡공건물": {
    "apt_name": "용인시 죽산박씨호곡공건물",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 죽전금강아파트": {
    "apt_name": "용인시 죽전금강아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "죽전벽산빌라트": {
    "apt_name": "죽전벽산빌라트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 200,
    "장애요인": "없음",
    "장애내용": ""
  },
  "죽전역월드메르디앙": {
    "apt_name": "죽전역월드메르디앙",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 죽전현대빌라트302동": {
    "apt_name": "용인시 죽전현대빌라트302동",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 300,
    "장애요인": "있음",
    "장애내용": "대피공간이 따로 없어서 지붕으로 연결된 계단이 전부인데 공간이 협소함."
  },
  "용인시 죽전현대홈타운": {
    "apt_name": "용인시 죽전현대홈타운",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 279,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 죽전e편한세상2차아파트": {
    "apt_name": "용인시 죽전e편한세상2차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 중동현대 I-PARK 어정마을 동백": {
    "apt_name": "용인시 중동현대 I-PARK 어정마을 동백",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 중앙하이츠빌": {
    "apt_name": "용인시 중앙하이츠빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 지석마을 임광그대가": {
    "apt_name": "용인시 지석마을 임광그대가",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 지석프라자": {
    "apt_name": "용인시 지석프라자",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 지음재": {
    "apt_name": "용인시 지음재",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진로아파트": {
    "apt_name": "용인시 진로아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진산마을삼성7차아파트": {
    "apt_name": "용인시 진산마을삼성7차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진우복합건물": {
    "apt_name": "용인시 진우복합건물",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진형월드아파트": {
    "apt_name": "용인시 진형월드아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진흥아파트93": {
    "apt_name": "용인시 진흥아파트93",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진흥아파트95": {
    "apt_name": "용인시 진흥아파트95",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 172,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 진흥아파트3차": {
    "apt_name": "용인시 진흥아파트3차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 청광아파트": {
    "apt_name": "용인시 청광아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 청구호수아파트": {
    "apt_name": "용인시 청구호수아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 청담 그랑주떼1,2,3 (공동주택 및 업무시설)": {
    "apt_name": "용인시 청담 그랑주떼1,2,3 (공동주택 및 업무시설)",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 청명센트레빌": {
    "apt_name": "용인시 청명센트레빌",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 청수상가아파트건물": {
    "apt_name": "용인시 청수상가아파트건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 50,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 청와아파트": {
    "apt_name": "용인시 청와아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 최호순건물(원룸형)": {
    "apt_name": "용인시 최호순건물(원룸형)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 코오롱하늘채아파트1단지": {
    "apt_name": "용인시 코오롱하늘채아파트1단지",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 태성아파트": {
    "apt_name": "용인시 태성아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 태양아파트": {
    "apt_name": "용인시 태양아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 태영데시앙2차아파트": {
    "apt_name": "용인시 태영데시앙2차아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 250,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 태영데시앙아파트": {
    "apt_name": "용인시 태영데시앙아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 태영아파트": {
    "apt_name": "용인시 태영아파트",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 200,
    "장애요인": "있음",
    "장애내용": "옥상출입문 열쇠로 잠겨있는 상태. 동대표가 열쇠 관리하고 있음"
  },
  "용인시 태영아파트2단지(용화마을)": {
    "apt_name": "용인시 태영아파트2단지(용화마을)",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 트리빌": {
    "apt_name": "용인시 트리빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 펠리체빌어성철외1인건물": {
    "apt_name": "용인시 펠리체빌어성철외1인건물",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 플러스빌": {
    "apt_name": "용인시 플러스빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 해바라기": {
    "apt_name": "용인시 해바라기",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 90,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 해피하우스": {
    "apt_name": "용인시 해피하우스",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1000,
    "장애요인": "있음",
    "장애내용": "생활용품 등 적치"
  },
  "용인시 헤렌하우스": {
    "apt_name": "용인시 헤렌하우스",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "용인시 힐스테이트아파트": {
    "apt_name": "용인시 힐스테이트아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 280,
    "장애요인": "없음",
    "장애내용": ""
  },
  "송탄 부영사랑으로": {
    "apt_name": "송탄 부영사랑으로",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 64,
    "장애요인": "있음",
    "장애내용": "박공지붕으로 옥상출구로 나가면 안전펜스가 있는곳은 5~6명 정도 대피할수 있고, 나머지 공간은 안전펜스가 없음."
  },
  "고양시 평화누리": {
    "apt_name": "고양시 평화누리",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 30,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 김광술": {
    "apt_name": "고양시 김광술",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시김광술": {
    "apt_name": "고양시김광술",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "있음",
    "장애내용": ""
  },
  "고양시 김덕중": {
    "apt_name": "고양시 김덕중",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음, 있음",
    "장애내용": ""
  },
  "고양시 김애영": {
    "apt_name": "고양시 김애영",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 100,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 김재헌": {
    "apt_name": "고양시 김재헌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 6,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 김철": {
    "apt_name": "고양시 김철",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 127.58,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 미니장미1차": {
    "apt_name": "고양시 미니장미1차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 35,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 변재중": {
    "apt_name": "고양시 변재중",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 91.22,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 신동진": {
    "apt_name": "고양시 신동진",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 110.49,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 안경분": {
    "apt_name": "고양시 안경분",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음, 있음",
    "장애내용": ""
  },
  "고양시 여성호": {
    "apt_name": "고양시 여성호",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 128.58,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 우점례": {
    "apt_name": "고양시 우점례",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음, 있음",
    "장애내용": ""
  },
  "고양시 이병길": {
    "apt_name": "고양시 이병길",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음, 있음",
    "장애내용": ""
  },
  "고양시 이장헌": {
    "apt_name": "고양시 이장헌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 10.08,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 이현숙": {
    "apt_name": "고양시 이현숙",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 179.25,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 전낙두": {
    "apt_name": "고양시 전낙두",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 180,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 조성문": {
    "apt_name": "고양시 조성문",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 조점임": {
    "apt_name": "고양시 조점임",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 132.94,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 최종채": {
    "apt_name": "고양시 최종채",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 128.58,
    "장애요인": "없음",
    "장애내용": ""
  },
  "고양시 한만호": {
    "apt_name": "고양시 한만호",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 74.31,
    "장애요인": "없음",
    "장애내용": ""
  },
  "광명 기아사원아파트": {
    "apt_name": "광명 기아사원아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 400,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 금호1": {
    "apt_name": "구리시 금호1",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 10,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 금호베스트빌": {
    "apt_name": "구리시 금호베스트빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 520,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 이건필그린아파트2차": {
    "apt_name": "구리시 이건필그린아파트2차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 이건필그린아파트3차": {
    "apt_name": "구리시 이건필그린아파트3차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 120,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 퍼플스퀘어": {
    "apt_name": "구리시 퍼플스퀘어",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 180,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 상보기숙사": {
    "apt_name": "구리시 상보기숙사",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 503.75,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 대우아파트": {
    "apt_name": "구리시 대우아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 3,
    "장애요인": "없음",
    "장애내용": ""
  },
  "구리시 오룡마을 한화": {
    "apt_name": "구리시 오룡마을 한화",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "남양주시 동부센트레빌": {
    "apt_name": "남양주시 동부센트레빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 280,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 누리애빌": {
    "apt_name": "부천시 누리애빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 114,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 디에치트라움": {
    "apt_name": "부천시 디에치트라움",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 145,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 리치빌": {
    "apt_name": "부천시 리치빌",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 81.6,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 복사골아파트": {
    "apt_name": "부천시 복사골아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 290,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 삼두1차": {
    "apt_name": "부천시 삼두1차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 삼보아파트": {
    "apt_name": "부천시 삼보아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 476,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 삼신아파트": {
    "apt_name": "부천시 삼신아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 726,
    "장애요인": "있음",
    "장애내용": "중간라인만 출입구, 나머지 라인은 사다리"
  },
  "부천시 삼우아파트": {
    "apt_name": "부천시 삼우아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 723,
    "장애요인": "있음",
    "장애내용": "사다리를 이용하여 뚜껑식 출입문을 통해 대피"
  },
  "부천시 스타르네상스아파트": {
    "apt_name": "부천시 스타르네상스아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 223,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 아남아파트": {
    "apt_name": "부천시 아남아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 451,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 전진아파트": {
    "apt_name": "부천시 전진아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 풍남아파트": {
    "apt_name": "부천시 풍남아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 670,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 해늘채아파트18": {
    "apt_name": "부천시 해늘채아파트18",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 98,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 하늘채아파트17": {
    "apt_name": "부천시 하늘채아파트17",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 222.7,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 한아름아파트": {
    "apt_name": "부천시 한아름아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 539,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 현대아파트86": {
    "apt_name": "부천시 현대아파트86",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 456,
    "장애요인": "없음",
    "장애내용": ""
  },
  "부천시 현대아파트88": {
    "apt_name": "부천시 현대아파트88",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 405,
    "장애요인": "있음",
    "장애내용": "사다리를 이용하여 뚜껑식 출입문을 통해 진입 가능함."
  },
  "수원시 남광하우스토리2": {
    "apt_name": "수원시 남광하우스토리2",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "없음, 있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키, 자동개폐장치",
    "유도등 설치여부": "미설치, 설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 20,
    "장애요인": "있음, 없음",
    "장애내용": "대피불가"
  },
  "수원시 남광하우스토리1": {
    "apt_name": "수원시 남광하우스토리1",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 20,
    "장애요인": "없음",
    "장애내용": ""
  },
  "수원시 대창빌딩": {
    "apt_name": "수원시 대창빌딩",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 164.7,
    "장애요인": "없음",
    "장애내용": ""
  },
  "수원시 미래아파트": {
    "apt_name": "수원시 미래아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 211,
    "장애요인": "없음",
    "장애내용": ""
  },
  "수원시 빌라제이": {
    "apt_name": "수원시 빌라제이",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 152.49,
    "장애요인": "없음",
    "장애내용": ""
  },
  "수원시 삼화아파트": {
    "apt_name": "수원시 삼화아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 30,
    "장애요인": "없음",
    "장애내용": ""
  },
  "수원시 팔달115-1": {
    "apt_name": "수원시 팔달115-1",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 80,
    "장애요인": "없음",
    "장애내용": ""
  },
  "시흥시 문정덕": {
    "apt_name": "시흥시 문정덕",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 16.615,
    "장애요인": "없음",
    "장애내용": ""
  },
  "시흥시 산호2": {
    "apt_name": "시흥시 산호2",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 900,
    "장애요인": "없음",
    "장애내용": ""
  },
  "시흥시 산호3": {
    "apt_name": "시흥시 산호3",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 534,
    "장애요인": "없음",
    "장애내용": ""
  },
  "시흥시 태광": {
    "apt_name": "시흥시 태광",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 500,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안산 리첸시아": {
    "apt_name": "안산 리첸시아",
    "addr": "",
    "지붕형태": "슬라브+박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 220,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안성 대림1차": {
    "apt_name": "안성 대림1차",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 278.58,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안성 원곡아파트": {
    "apt_name": "안성 원곡아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 238.8,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안양시 덕원2차": {
    "apt_name": "안양시 덕원2차",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "있음",
    "장애내용": "최상층 사다리를 이용하여 점검구로 이동후 옥상으로 출입이 가능하나 대피로로 부적정, 일부라인 옥상없음"
  },
  "안양시 삼호아파트": {
    "apt_name": "안양시 삼호아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 150,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안양시 성원아파트": {
    "apt_name": "안양시 성원아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 1600,
    "장애요인": "없음",
    "장애내용": ""
  },
  "안양시 송림아파트": {
    "apt_name": "안양시 송림아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "안양시 영풍아파트": {
    "apt_name": "안양시 영풍아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 140,
    "장애요인": "있음",
    "장애내용": "옥상출입문을 통해 나가면 승강기 기계실로 올라가는 계단이 나오고 벽을 넘어야 박공지붕이 나옴"
  },
  "안양시 우양아파트": {
    "apt_name": "안양시 우양아파트",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 66,
    "장애요인": "있음",
    "장애내용": "자바라문 설치되어 있으나 잠겨있음"
  },
  "양주시 이상도": {
    "apt_name": "양주시 이상도",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 300,
    "장애요인": "없음",
    "장애내용": ""
  },
  "양평군 강남교직원 사택": {
    "apt_name": "양평군 강남교직원 사택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": "약65",
    "장애요인": "없음",
    "장애내용": ""
  },
  "양평군 양평군전자과학고등학교 직원사택": {
    "apt_name": "양평군 양평군전자과학고등학교 직원사택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": "약35",
    "장애요인": "없음",
    "장애내용": ""
  },
  "양평군 연천1교직원 사택": {
    "apt_name": "양평군 연천1교직원 사택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "",
    "옥상출입문 설치여부": "미설치",
    "옥상 출입문 위치": "",
    "옥상 출입문 재질": "",
    "옥상 출입문 개방관리": "",
    "유도등 설치여부": "",
    "점등상태": "",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  },
  "양평군 전곡교직원 사택": {
    "apt_name": "양평군 전곡교직원 사택",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 272.76,
    "장애요인": "없음",
    "장애내용": ""
  },
  "경기청북부청사생활관": {
    "apt_name": "경기청북부청사생활관",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "항시개방",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 736.6,
    "장애요인": "없음",
    "장애내용": ""
  },
  "신한대학교의정부캠퍼스기숙사카르멜": {
    "apt_name": "신한대학교의정부캠퍼스기숙사카르멜",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "있음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층 아래층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "자동개폐장치",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "설치",
    "대피공간 면적": 813,
    "장애요인": "없음",
    "장애내용": ""
  },
  "행복마을25사단군인아파트": {
    "apt_name": "행복마을25사단군인아파트",
    "addr": "",
    "지붕형태": "박공",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "불연재",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "미설치",
    "점등상태": "",
    "대피공간내 난간설치": "미설치",
    "대피공간 면적": 0,
    "장애요인": "있음",
    "장애내용": "박공지붕형태로서 대피공간 확보안됨"
  },
  "평택 서선희": {
    "apt_name": "평택 서선희",
    "addr": "",
    "지붕형태": "슬라브",
    "옥상 대피공간": "없음",
    "옥상출입문 설치여부": "설치",
    "옥상 출입문 위치": "최상층",
    "옥상 출입문 재질": "방화문",
    "옥상 출입문 개방관리": "열쇠 또는 번호키",
    "유도등 설치여부": "설치",
    "점등상태": "점등",
    "대피공간내 난간설치": "",
    "대피공간 면적": "",
    "장애요인": "없음",
    "장애내용": ""
  }
}

export {
    중복체크,
    주소없음
 }
